// extracted by mini-css-extract-plugin
export default {"price":"e6-z","onSale":"f6-z","msrpLabelPrice":"g6-z","msrpLabel":"h6-z","originalPrice":"i6-z","percentOff":"j6-z"};